import React from 'react';
import { css, cx } from 'linaria';
import ButtonWithLoading from '../../../ui/Button';
import { theme } from '../../../Theme';

export function VariantSelector({
  product,
  variantHandler,
  showValidation,
  disableOutOfStock
}) {
  return (
    <div className={sharedStyles}>
      {product?.variants?.options?.map((option, index) => {
        let showValidationMessage = false;
        if (
          showValidation &&
          variantHandler.getMissingOptions()?.includes(option)
        ) {
          showValidationMessage = true;
        }

        return (
          <ButtonSelect
            option={option}
            variantHandler={variantHandler}
            key={option.name}
            showValidationMessage={showValidationMessage}
            disableOutOfStock={disableOutOfStock}
            doNotDisable={index === 0}
          />
        );
      })}
    </div>
  );
}

const sharedStyles = css`
  margin-bottom: 40px;
  label {
    display: flex;
    padding-bottom: 0.25em;
    margin-top: 1em;
    align-items: center;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .invalid {
    label {
      color: #eb5757;
    }
  }
  .missingVariant {
    margin-right: 0.25em;
    height: 10px;
    width: 10px;
  }
`;

function ButtonSelect({
  option,
  variantHandler,
  showValidationMessage,
  disableOutOfStock,
  doNotDisable
}) {
  const { getSelectedValue, validateSelection, selectValue } = variantHandler;
  const selectedValue = getSelectedValue(option);
  // const t = useIntl();

  return (
    <div
      className={cx(
        'button-select',
        buttonSelectStyles,
        showValidationMessage && 'invalid'
      )}
    >
      {/* <label>{t('Select {optionName}', { optionName: option.name })}</label> */}
      <label>{option.name}</label>
      {option?.values?.map(value => {
        const validation = validateSelection(value, option);
        return (
          <ButtonWithLoading
            data-testid={option.name + value}
            key={option.name + value}
            onClick={() => selectValue(value, option)}
            disabled={
              !doNotDisable &&
              (validation === 'invalid' ||
                (disableOutOfStock && validation === 'outOfStock'))
            }
            secondary={value !== selectedValue}
            aria-pressed={value === selectedValue}
          >
            {value}
          </ButtonWithLoading>
        );
      })}
    </div>
  );
}

const buttonSelectStyles = css`
  margin: 1em 0;
  button {
    width: 80px;
    background: ${theme.colors.accent} !important;
    border: 0 !important;
    padding: 0 10px 0 10px !important;
    height: 35px;
    min-width: 50px;
    border-radius: ${theme.button.desktop.borderRadius} !important;
    &.secondary {
      background: #e9e5df !important;
      :hover {
        background: ${theme.colors.accentlight} !important;
      }
    }
    + button {
      margin-left: 0.5em;
    }
  }
  &.invalid button {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
`;
